import { apiSlice } from "../../app/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({

    endpoints: builder => ({
        getUsers: builder.query({
            query: () => '/users',
            providesTags: ['Users'],

        }),

        getUsersStats: builder.query({
            query: () => '/users/stats',
            keepUnusedDataFor: 1,
            providesTags: ['Users'],

        }),
        getUserMe: builder.query({
            query: () => ({
                url: `/users/user/me?t=${Date.now()}`,
                method: 'GET',
                cache: 'no-store',
            }),
            providesTags: ['Users'],
            refetchOnMountOrArgChange: true,
            keepUnusedDataFor: 0,

        }),

        updateUser: builder.mutation({
            query: (data) => {
                const { userId, updateData } = data
                return {
                    url: `/users/${userId}`,
                    method: 'PUT',
                    body: updateData
                }
            },
            invalidatesTags: ['Users'],

        }),
        sendOtp: builder.mutation({
            query: (data) => {
                const { phoneNumber } = data
                return {
                    url: `/otp/send-otp`,
                    method: 'POST',
                    body: { phoneNumber }
                }
            }
        }),
        verifyOtp: builder.mutation({
            query: (data) => {
                const { phone, otp } = data
                return {
                  url: `/auth/verify-otp`,
                  method: 'POST',
                  body: { phone, otp },
                }
            }
        }),

        deleteUser: builder.mutation({
            query: (data) => {
                // accepts either userId OR { userId, password }
                if (typeof data === 'string') {
                  return { url: `/users/${data}` , method: 'DELETE' }
                }
                const { userId, password } = data || {}
                return {
                  url: `/users/${userId}`,
                  method: 'DELETE',
                  body: password ? { password } : undefined
                }
            },
            invalidatesTags: ['Users'],
        }),

        updatePassword: builder.mutation({
            query: (data) => {
                const { userId, updateData } = data
                return {
                    url: `/change-password/${userId}`,
                    method: 'PUT',
                    body: updateData
                }
            }
        }),


    })
})

export const {
    useGetUsersQuery,
    useGetUsersStatsQuery,
    useUpdateUserMutation,
    useGetUserMeQuery,
    useSendOtpMutation,
    useVerifyOtpMutation,
    useDeleteUserMutation,
    useUpdatePasswordMutation,
} = usersApiSlice